export default __webpack_public_path__ + "static/media/about-section-06.723d5358.webp";